/**
 * LENCANA NOTIFIKASI `107:220` — apa yang dirender, dan KAPAN ia tidak dirender.
 *
 * MENGAPA BERKAS INI ADA — cacat 3, temuan pemilik proyek 28 September 2026
 * -----------------------------------------------------------------------
 * Figma menggambar `3`. Yang berdiri di produksi adalah lingkaran berisi `0` di setiap
 * layar konsol. Sebuah lingkaran berisi nol menempati ruang bilah atas untuk mengatakan
 * "tidak ada apa-apa" — yang sudah dikatakan lebih baik, dan tanpa ruang sama sekali, oleh
 * tidak adanya lencana. Angka nol di dalam lencana juga MELATIH mata mengabaikannya, jadi
 * ketika angkanya kelak menjadi `3` ia tidak lagi menarik perhatian.
 *
 * TIGA KEADAAN, DAN KEADAAN KETIGA BUKAN ANGKA
 * -------------------------------------------
 *   · `null` → `—`. Ini keputusan yang SUDAH BENAR dan DIPERTAHANKAN; alasannya tertulis di
 *     PENERJEMAHAN-DESAIN.md §2.3. Sebelum jawabannya tiba, "nol" dan "belum tahu" adalah
 *     dua hal yang berbeda, dan lencana yang menampilkan `0` selama pemuatan berbohong
 *     selama seperempat detik pada setiap perpindahan layar.
 *   · `0`    → TIDAK DIRENDER.
 *   · `> 0`  → angkanya, apa adanya.
 *
 * KENAPA SEBUAH FUNGSI DAN BUKAN TERNARY DI DALAM JSX
 * --------------------------------------------------
 * Karena keadaan `0` TIDAK DAPAT diuji dari `renderToStaticMarkup`: `useEffect` tidak
 * berjalan di sana, jadi hitungannya selamanya `null`. Sebuah keputusan yang hanya hidup di
 * dalam JSX karena itu hanya dapat diuji oleh peramban — dan gerbang yang menuntut peramban
 * adalah gerbang yang ditemui terlambat. Di sini ia dapat diuji tanpa satu pun.
 */

export interface KeadaanLencana {
  /** Salah berarti elemen lencananya TIDAK dirender — bukan dirender kosong. */
  tampil: boolean;
  /** Teks di dalam lencana, atau `null` ketika ia tidak dirender. */
  teks: string | null;
}

/**
 * @param belumTerbaca `null` selama jawabannya belum tiba; angka sesudahnya.
 */
export function lencanaNotifikasi(belumTerbaca: number | null): KeadaanLencana {
  if (belumTerbaca === null) return { tampil: true, teks: '—' };

  /**
   * `<= 0` dan bukan `=== 0`. Angka negatif tidak dapat datang dari
   * `GET /v1/notifications` yang sehat, dan justru karena itu ia diperlakukan di sini:
   * sebuah lencana berisi `-1` lebih buruk daripada lencana berisi nol, dan "mustahil"
   * bukan alasan untuk tidak menuliskan apa yang terjadi bila ia tiba.
   */
  if (belumTerbaca <= 0) return { tampil: false, teks: null };

  return { tampil: true, teks: String(belumTerbaca) };
}
